var exports = {
  "U": "x2b2fbebb--0ba89a--buttons",
  "x": "x2b2fbebb--0ba89a--button",
};

module.exports = exports;
